// exclude-from-index
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Text from '../../../BuildingBlocks/Text';
import { DrawerSelectContainer, SelectValue, FormattedCopyMini } from './DrawerSelect.styles';
import ArrowIcon from '../../../SVGIcon/icons/ArrowIcon';
import { colors } from '../../../css';

const propertiesLabelParser = (label, totalProperties) =>
  label.split(' ').map(word =>
    word === '{n}' ? (
      <FormattedCopyMini noMargins key={word} tagName="span" color="tertiary">
        {totalProperties}
        &nbsp;
      </FormattedCopyMini>
    ) : (
      <FormattedCopyMini noMargins key={word} tagName="span" color="tertiary">
        {word}
        &nbsp;
      </FormattedCopyMini>
    )
  );

function ArrowIconComponent() {
  return <ArrowIcon iconColor={colors.colorBlue} width="14px" />;
}
class DrawerSelect extends React.Component {
  static propTypes = {
    currentOptionIndex: PropTypes.number,
    options: PropTypes.arrayOf(PropTypes.string),
    selectLabel: PropTypes.string,
    propertiesLabel: PropTypes.string,
    onChange: PropTypes.func,
    totalProperties: PropTypes.number.isRequired
  };

  static defaultProps = {
    options: ['Relevance', 'Price', 'Name'],
    currentOptionIndex: 0,
    selectLabel: 'Sort by:',
    propertiesLabel: '{n} Properties',
    onChange: () => {}
  };

  constructor(props) {
    super(props);

    const { options, currentOptionIndex } = this.props;

    this.state = { currentOption: options[currentOptionIndex] };
    this.handlechange = this.handlechange.bind(this);
  }

  handlechange(event) {
    const { onChange } = this.props;

    this.setState({
      currentOption: event.target.value
    });

    onChange(event);
  }

  render() {
    const { options, selectLabel, propertiesLabel, totalProperties } = this.props;
    const { currentOption } = this.state;

    return (
      <DrawerSelectContainer>
        <div className="properties-details">
          <Text.HeadingFifth noMargins tagName="span">
            Search Results &nbsp;
          </Text.HeadingFifth>
          {propertiesLabelParser(propertiesLabel, totalProperties)}
        </div>
        <div style={{ display: 'flex' }}>
          <div className="select-group">
            {totalProperties ? (
              <>
                <FormattedCopyMini color="tertiary" className="select-label" tagName="span">
                  {selectLabel}
                </FormattedCopyMini>
                <Select
                  IconComponent={ArrowIconComponent}
                  onChange={this.handlechange}
                  value={currentOption}
                  disableUnderline
                  renderValue={option => (
                    <SelectValue noMargins weight="bold">
                      {option}
                    </SelectValue>
                  )}
                >
                  {options.map(option => (
                    <MenuItem key={option} value={option}>
                      <Text.CopyMini noMargins weight="bold">
                        {option}
                      </Text.CopyMini>
                    </MenuItem>
                  ))}
                </Select>
              </>
            ) : null}
          </div>
        </div>
      </DrawerSelectContainer>
    );
  }
}

export default DrawerSelect;
